import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
const ModalReporteCompromiso = (props) => {
  const op = require("../../modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
  const fechaActual = new Date();
  const [desde, setDesde] = useState(new Date(efiscalanio, 0, 1));
  const [hasta, setHasta] = useState(
    new Date(efiscalanio, fechaActual.getMonth(), fechaActual.getDate()),
  );
  const [titulo, setTitulo] = useState("Reporte Ordenes de Pago");

  const imprimir = () => {
    try {
      let condi = `CPG.Fecha Between '${desde.toISOString().split("T")[0]}' AND '${hasta.toISOString().split("T")[0]}'`;
      let reporte = `Pres_CompromisoFch`;
      if (props.tipo) {
        if (props.tipo === "Por Causar") {
          condi += ` AND CPG.status = 0 and CPG.reversado = 0`;
        } else if (props.tipo === "Causados") {
          condi += ` AND CPG.status = 1 and CPG.reversado = 0`;
        } else if (props.tipo === "Reversados") {
          condi += ` AND CPG.reversado = 1`;
          reporte = `Pres_CompromisoFchRever`;
        } else if (props.tipo === "Total") {
          reporte = `Pres_CompromisoFchRever`;
        }
      }
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          `reporte=${reporte}` +
          "&idfiscal=" +
          idefiscal +
          "&sql=" +
          condi +
          `&sql1=DESDE EL '${desde.toISOString().split("T")[0]}' HASTA EL '${hasta.toISOString().split("T")[0]}'` +
          `&sql2=${moment(desde).format("DD-MM-YYYY")}` +
          `&sql3=${moment(hasta).format("DD-MM-YYYY")}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      cerrar();
    } catch (error) {
      console.error("Error al generar el reporte:", error);
    }
  };
  const cerrar = () => {
    props.cancelar();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props && props.tipo) {
          const { tipo } = props;
          if (tipo === "Causados") {
            setTitulo("Reporte Compromisos (Causados)");
          } else if (tipo === "Por Causar") {
            setTitulo("Reporte Compromisos (x Causar)");
          } else if (tipo === "Reversados") {
            setTitulo("Reporte Compromisos (Reversados)");
          } else {
            setTitulo("Reporte Compromisos");
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">{titulo}</h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 mx-auto row my-auto py-0">
          <div className="input-group input-group-sm col-md-5 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Desde la Fecha:
            </span>
            <input
              type="date"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              defaultValue={moment(desde).format("YYYY-MM-DD")}
              onChange={(e) => {
                setDesde(new Date(e.target.value));
              }}
            />
          </div>
          <div className="input-group input-group-sm col-md-5 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Hasta la Fecha:
            </span>
            <input
              type="date"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              defaultValue={moment(hasta).format("YYYY-MM-DD")}
              onChange={(e) => {
                setHasta(new Date(e.target.value));
              }}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-primary text-uppercase"
          onClick={imprimir}
        >
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button
          className="btn btn-sm btn-danger text-uppercase"
          onClick={cerrar}
        >
          <i className="fas fa-times me-1"></i> Salir
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalReporteCompromiso;
